import styles from './DailyActionDialog.module.scss';

type Props = {
  title: string;
  description: string;
  icon: string;
};

export function DailyActionDialog({ title, icon, description }: Props) {
  return (
    <div className={styles.body}>
      <img src={icon} alt={`${title} Logo`} className={styles.icon} />
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.content}>{description}</div>
    </div>
  );
}
